module.exports = __webpack_public_path__ + "static/media/dropdown-icon.7f876a24.svg";